<template>
  <div class="dashboard__view customers">
    <div class="page">
      <div class="page__title"></div>
    </div>

    <div class="list">
      <div class="tab__content">
        <div class="tab__content__top">
          <div class="tab__content__top__left">
            {{ pageInfo.total }} Customers
          </div>
          <div class="tab__content__top__right">
            <div class="tab__content__top__item">
              <button
                @click="clearFilter"
                class="btn btn--sm btn--default"
                v-if="openFilters"
              >
                Clear Filter
              </button>
            </div>
            <div class="tab__content__top__item">
              <button
                @click="openFilters = true"
                class="btn btn--sm btn--default"
              >
                Filter
              </button>
            </div>
            <div class="tab__content__top__item">
              <button
                :disabled="exportDisabled"
                @click="exportData"
                class="customers-btn btn btn--sm btn--flex btn--default"
                v-if="customerList.length > 0"
              >
                <span class="btn--icon">
                  <svg
                    fill="none"
                    height="12"
                    viewBox="0 0 14 18"
                    width="14"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.25 0V12.4219L2.28906 8.46094L1.21094 9.53906L6.46094 14.7891L7 15.3047L7.53906 14.7891L12.7891 9.53906L11.7109 8.46094L7.75 12.4219V0H6.25ZM0.25 16.5V18H13.75V16.5H0.25Z"
                      fill="#e00b5b"
                    />
                  </svg>
                </span>
                <div class="btn--text" v-if="exportDisabled">Exporting...</div>
                <div class="btn--text" v-else>Export</div>
              </button>
            </div>
          </div>
        </div>
        <div
          class="tab__content__top"
          style="padding-top: 0"
          v-if="openFilters"
        >
          <div class="tab__content__top__left">.</div>
          <div class="tab__content__top__right">
            <form @submit.prevent="triggerFilter">
              <div class="filter">
                <div class="form__item">
                  <div class="form__label">Reference</div>
                  <input
                    class="form__input"
                    type="text"
                    v-model="filterList.reference"
                  />
                </div>
                <div class="form__item">
                  <div class="form__label">VNUBAN</div>
                  <input
                    class="form__input vNuban__input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    maxlength="10"
                    @keypress="isNumber($event)"
                    type="number"
                    v-model="filterList.vnuban"
                  />
                </div>
                <div class="form__item">
                  <div class="form__label">Status</div>
                  <div class="select">
                    <select
                      class="select__input select__input--sm"
                      v-model="filterList.status"
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                    <div class="select__icon">
                      <svg
                        height="10"
                        viewBox="0 0 6 10"
                        width="6"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                          fill="#637381"
                          fill-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="form__item">
                  <div class="form__label">From Date</div>
                  <datepicker class="form__input" v-model="filterList.from" />
                </div>
                <div class="form__item">
                  <div class="form__label">To Date</div>
                  <datepicker class="form__input" v-model="filterList.to" />
                </div>
                <div class="form__item" style="padding-top: 33px">
                  <button
                    :disabled="disabled"
                    class="btn btn--primary btn--filter"
                    type="submit"
                  >
                    Apply Filter
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <EmptyState v-if="emptyState" type="not-found" icon="customer" />

        <div v-else>
          <!-- Loader -->
          <div class="loader" v-if="loading">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>
          <table class="table card-table" v-else>
            <thead>
              <tr>
                <th>CUSTOMER</th>
                <th>PHONE</th>
                <th>NUBAN</th>
                <th>REFERENCE</th>
                <th>CREATED</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              <router-link
                :key="item.unique_reference"
                :to="{ name: 'customers-details', params: { id: item.vnuban } }"
                tag="tr"
                v-for="(item, key) in customerList"
              >
                <td>
                  <span class="name">{{ item.account_name }}</span>
                  <span class="email">{{ item.account_email }}</span>
                </td>
                <td>{{ item.account_mobile_number }}</td>
                <td>{{ item.vnuban }}</td>
                <td>
                  {{ item.account_reference }}
                </td>
                <td>{{ item.created_at | date }}</td>
                <td class="act">
                  <button
                    :disabled="deactivateDisabled[key]"
                    @click.prevent="deactivate(item, key)"
                    class="btn btn--sm btn--danger"
                    v-if="item.status == 'ACTIVE'"
                  >
                    <span v-if="deactivateDisabled[key]">Deactivating...</span>
                    <span v-else>Deactivate</span>
                  </button>
                  <button
                    :disabled="activateDisabled[key]"
                    @click.prevent="activate(item, key)"
                    class="btn btn--sm btn--primary"
                    v-if="item.status == 'INACTIVE'"
                  >
                    <span v-if="activateDisabled[key]">Activating...</span>
                    <span v-else>Activate</span>
                  </button>
                </td>
              </router-link>
            </tbody>
          </table>
           <div
            class="table__details"
            v-if="loading !== true && emptyState !== true"
          >
            <div class="table__details__left">
              <span class="text-muted" v-if="pageInfo.total"
                >Page {{ pageInfo.current_page }} of
                {{ pageInfo.total_pages }}</span
              >
            </div>
            <div class="table__details__right">
              <Pagination :numberOfPages="pageInfo.total_pages" />
            </div>
            <div class="table__details__right"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import emptyTransactions from "../../../components/emptytransactions";
import Pagination from "@/components/pagination.vue";

import Vue from "vue";
import EmptyState from "@/components/empty-state.vue";

export default {
  metaInfo: {
    title: "Customers",
  },
  data() {
    return {
      customerList: "",
      pageInfo: "",
      perPage: 10,
      accountReference: {
        value: "",
        empty: false,
      },
      accountName: {
        value: "",
        empty: false,
      },
      accountEmail: {
        value: "",
        empty: false,
      },
      accountMobileNumber: {
        value: "",
        empty: false,
      },
      bvn: {
        value: "",
        empty: false,
      },
      expiresOn: {
        value: "",
        empty: false,
      },
      useFrequency: {
        value: "",
        empty: false,
      },
      callbackUrl: {
        value: "",
        empty: false,
      },
      destinationNuban: {
        value: "",
        empty: false,
      },
      vnuban: "",
      disabled: false,
      filterList: {
        reference: this.$route.query.account_reference
          ? this.$route.query.account_reference
          : "",
        vnuban: this.$route.query.vnuban ? this.$route.query.vnuban : "",
        status: this.$route.query.status ? this.$route.query.status : "",
        from: this.$route.query.from ? this.$route.query.from : "",
        to: this.$route.query.to ? this.$route.query.to : "",
      },
      polling: "",
      bulkFile: {
        url: "",
        filename: "",
      },
      exportDisabled: false,
      activateDisabled: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      deactivateDisabled: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      loading: true,
      emptyState: false,
      openFilters: false,
    };
  },

  created() {
    this.fetchcustomers();
  },

  computed: {
    mode() {
      return this.$store.state.mode;
    },
    userDetails() {
      return this.$store.state.userDetails;
    },
  },

  components: {
    Datepicker,
    emptyTransactions,
    Pagination, EmptyState
  },

  watch: {
    // call again the fetch method if the route changes; this is necessary especially because of users
    // using the search and might be on this route already.
    $route: "fetchcustomers",
  },

  methods: {
    generatePaginationLink(pageNum) {
      return {
        path: "/dashboard/customers",
        query: {
          ...this.$route.query,
          page: pageNum,
        },
      };
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    triggerFilter() {
      let queryObject = {};
      if (this.filterList.reference !== "") {
        queryObject.account_reference = this.filterList.reference.trim();
      }
      if (this.filterList.vnuban !== "") {
        queryObject.vnuban = this.filterList.vnuban.trim();
      }
      if (this.filterList.status !== "") {
        queryObject.status = this.filterList.status;
      }
      if (this.filterList.from !== "") {
        queryObject.from = moment(this.filterList.from).format("YYYY-MM-DD 00:00:00");
      }

      if (this.filterList.to !== "") {
        queryObject.to = moment(this.filterList.to).format("YYYY-MM-DD 23:59:59");
      }

      queryObject.page = 1;

      //Route to page with query
      this.$router.push({ path: "/dashboard/customers", query: queryObject });
    },
    clearFilter() {
      this.filterList = {
        reference: "",
        vnuban: "",
        status: "",
        to: "",
        from: "",
      };
      this.openFilters = false;
      this.$router.push({ path: "/dashboard/customers?page=1" });
    },
    fetchcustomers() {
      // Convert object to multiple arrays with name and value
      let queryParams = Object.entries(this.$route.query);
      let generatedQuery = "";
      let i = 0;
      let appendedQuery = "";
      // Loop through arrays and generate the query string
      for (let [name, value] of queryParams) {
        generatedQuery += `${name}=${value}`;
        i++;
        if (i < queryParams.length) {
          generatedQuery += "&";
        }
      }

      // check for mode to append query
      if (this.mode) {
        appendedQuery = "&ignore_admin_flag=1";
      } else {
        appendedQuery = "&ignore_admin_flag=1&is_test=1";
      }

      this.$http
        .get(`admin/vnubans?${generatedQuery}${appendedQuery}`)
        .then((response) => {
          if (response.body.data.vnubans.length > 0) {
            this.customerList = response.body.data.vnubans;
            this.pageInfo = response.body.data.page_info;
            this.emptyState = false;
            this.loading = false;
          } else {
            this.emptyState = true;
            this.loading = false;
          }
        })
        .catch((error) => {
          // LOG Error
        });
    },

    deactivate(value, key) {
      // Since Arrays are not reactively we have to manually update the data.
      // (variable, array position, value)
      Vue.set(this.deactivateDisabled, [key], true);
      this.$http
        .post(`dashboard/vnubans/${value.vnuban}/deactivate`)
        .then((response) => {
          // Notifiy user
          this.$notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Success",
            text: response.body.message,
          });
          // Update customer list
          this.fetchcustomers();
          Vue.set(this.deactivateDisabled, [key], false);
        })
        .catch((error) => {
          this.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message,
          });
          Vue.set(this.deactivateDisabled, [key], false);
        });
    },
    activate(value, key) {
      // Since Arrays are not reactively we have to manually update the data.
      // (variable, array position, value)
      Vue.set(this.activateDisabled, [key], true);
      this.$http
        .post(`dashboard/vnubans/${value.vnuban}/activate`)
        .then((response) => {
          // Notifiy user
          this.$notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Success",
            text: response.body.message,
          });
          // Update customer list
          this.fetchcustomers();
          // Undisable button
          Vue.set(this.activateDisabled, [key], false);
        })
        .catch((error) => {
          this.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message,
          });
          Vue.set(this.activateDisabled, [key], false);
        });
    },
    exportData() {
      this.exportDisabled = true;
      let generatedQuery = this.returnQuery();
      let url = process.env.VUE_APP_API_URL;
      const token = this.userDetails.token;
      url = `${url}/admin/vnubans?download=1&${generatedQuery}&token=${token}`;
      window.open(url);
      setTimeout(() => {
        this.exportDisabled = false;
        this.$notify({
          group: "notifications-default",
          type: "success text-white",
          title: "Success",
          text: "Exporting in progress please wait..",
        });
      }, 3000);
      // this.$http
      //   .get(`admin/vnubans?download=1&${generatedQuery}&token=${token}`)
      //   .then((response) => {
      //     // Start polling the api every 3 seconds for data
      //     this.polling = setInterval(() => {
      //       this.pollDownload(response.body.data.file_identifier);
      //       this.$notify({
      //         group: "notifications-default",
      //         type: "success text-white",
      //         title: "Success",
      //         text: "Exporting in progress please wait..",
      //       });
      //     }, 3000);
      //   })
      //   .catch((error) => {
      //     this.exportDisabled = false;
      //     this.$notify({
      //       group: "notifications-default",
      //       type: "error text-white",
      //       title: "Error",
      //       text: error.body.message,
      //     });
      //   });
    },
    returnQuery() {
      let queryParams = Object.entries(this.$route.query);
      let generatedQuery = "";
      let i = 0;
      // Loop through arrays and generate the query string
      for (let [name, value] of queryParams) {
        generatedQuery += `${name}=${value}`;
        i++;
        if (i < queryParams.length) {
          generatedQuery += "&";
        }
      }
      return generatedQuery;
    },
    pollDownload(identifier) {
      this.$http.get(`dashboard/downloads/${identifier}`).then((response) => {
        // if data is available stop polling
        this.exportDisabled = false;
        clearInterval(this.polling);
        window.location.assign(response.body.data.file_url);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.customers {
  select, input, .vdp-datepicker, button {
    height: 42px;
  }
}
.name {
  color: #261940;
  display: block;
  margin-bottom: 4px;
}

.vNuban__input::-webkit-inner-spin-button,
.vNuban__input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.email {
  color: rgba(38, 25, 64, 0.6);
  font-size: 12px;
}

.page__link {
  color: rgba(38, 25, 64, 0.6);
  font-size: 14px;
  line-height: 20px;
  padding: 12px 24px;
  text-decoration: none;
  display: block;
  &:hover {
    color: #e00b5b;
  }
}
</style>